export default "__VITE_ASSET__BWz8vzOM__"